(() => {
  const registeredCreditCardRadioButton = '#credit_card_form_payment_method_registered_creditcard'
  const creditCardRadioButton = '#credit_card_form_payment_method_creditcard'
  const bankTransferRadioButton = '#credit_card_form_payment_method_bank_transfer'
  const amazonpayRadioButton = '#credit_card_form_payment_method_amazonpay'
  const paypayRadioButton = '#credit_card_form_payment_method_paypay'
  const linepayRadioButton = '#credit_card_form_payment_method_linepay'
  const merpayRadioButton = '#credit_card_form_payment_method_merpay'
  const eventReservationConfirmButton = '.event-reservation-confirm-button'

  const init = () => {
    $('.show-payment-active-button').hide();
    $('.payment-disabled-button').prop('disabled', true);
    $('body')
      .on('click', registeredCreditCardRadioButton, disabledFalseNextButton)
      .on('click', creditCardRadioButton, disabledFalseNextButton)
      .on('click', bankTransferRadioButton, disabledFalseNextButton)
      .on('click', amazonpayRadioButton, disabledFalseNextButton)
      .on('click', paypayRadioButton, disabledFalseNextButton)
      .on('click', linepayRadioButton, disabledFalseNextButton)
      .on('click', merpayRadioButton, disabledFalseNextButton);
    disabledFalseNextButton();
  }

  const disabledFalseNextButton = () => {
    if ($('input[name=credit_card_form\\[payment_method\\]]:checked').length > 0) {
      $('.show-payment-active-button').show();
      $('.show-payment-disabled-button').hide();
    }
  }
  $(init);
})();

